export default __webpack_public_path__ + "static/media/wwf_cube.8e5a3d99.jpg";